export enum CrmAceMappingActions {
  SET_ACE_FIELDS = 'SET_ACE_FIELDS',
  SET_MAPPING_FIELD = 'SET_MAPPING_FIELD',
  SET_MAPPING_KEY_VALUE = 'SET_MAPPING_KEY_VALUE',
  GET_CRM_FIELDS = 'GET_CRM_FIELDS',
  GET_ACE_FIELDS = 'GET_ACE_FIELDS',
  SET_MANDATORY_FIELDS = 'SET_MANDATORY_FIELDS',
  ADD_EMPTY_MANDATORY_FIELD_ROW = 'ADD_EMPTY_MANDATORY_FIELD_ROW',
  SET_GET_MAPPED_DATA = 'SET_GET_MAPPED_DATA',
  MAPPING_CLEANUP = 'MAPPING_CLEANUP',
  REMOVE_MANDATORY_FIELD_ROW = 'REMOVE_MANDATORY_FIELD_ROW',
  SET_HAS_RULES = 'SET_HAS_RULES',
  SET_CRM_TABLES = 'SET_CRM_TABLES',
  SET_MAPPING_PARENT_TABLE = 'SET_MAPPING_PARENT_TABLE',
}
